<template>
  <div>
    <el-dialog
      title="New Telegram channel"
      :visible.sync="showDialog"
      :before-close="handleClose"
      :center="true"
      append-to-body
    >
      <span slot="title">
        <h1><i class="fa fa-telegram"></i> Telegram channel</h1>
      </span>

      <el-row>
        <el-col
          :offset="4"
          :span="18"
        >
          <el-steps
            class="telegramSteps"
            :active="activeStep"
            align-center
            finish-status="success"
          >
            <el-step title="Request Code" />
            <el-step title="Sign in" />
            <el-step title="Finished" />
          </el-steps>
        </el-col>
      </el-row>
      <br />

      <el-row>
        <el-col
          :span="24"
          class="center"
        >
          <p v-if="activeStep == 0">Please choose your country and enter your phone number.</p>
          <p v-if="activeStep == 1"> The login code has been sent to <strong> {{ fullPhoneNumber }}</strong>. <br /><br />Please enter your code below or click <a @click="onClickChangeNumber"> here</a> to change your number.</p>
          <br />
        </el-col>
      </el-row>
      <hr>
      <br>
      <el-row :gutter="20">
        <el-col
          :offset="4"
          :span="18"
        >
          <el-alert
            v-if="codeRequestHasFailed || validationError"
            class="alert"
            title="Code request failed"
            type="error"
            :closable="false"
          >
            {{ errorMessage }}
          </el-alert>
          <br v-if="codeRequestHasFailed || validationError">
        </el-col>
      </el-row>

      <el-row>
        <el-col
          :offset="4"
          :span="18"
        >
          <el-form
            :model="telegramChannelForm"
            ref="telegramChannelForm"
            v-if="activeStep == 0"
            label-width="120px"
          >
            <el-form-item
              label="Country"
              prop="countryCode"
            >
              <country-code-selector
                class="country-selector"
                :selectedCountry="selectedCountry.code"
                :browserCountryCode="userCountryCode"
                @onCountryChanged="handleCountryChanged"
              >
              </country-code-selector>
            </el-form-item>
            <el-form-item label="Phone number">
              <el-input
                placeholder="Phone number"
                v-model="telegramChannelForm.phoneNumber"
              >
                <template slot="prepend">
                  {{ selectedCountry.flag }}
                  {{ selectedCountry.dial_code }}
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="Account status">
              <P>Do you have a Telegram account?</P>
              <el-radio-group v-model="existingAccount">
                <el-radio-button label="Yes"></el-radio-button>
                <el-radio-button label="No"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div v-if="existingAccount == 'No'">
              <hr>
              <el-row>
                <el-col
                  :span="20"
                  :offset="2"
                >
                  <small>
                    <p class="center">Telegram requires you to add a This is what other users will see when they view your contact on Telegram,
                      this is required by Telegram, we suggest using your station name instead.</p>
                  </small>
                </el-col>
              </el-row>
              <el-form-item label="First name">
                <el-input
                  placeholder="ACME"
                  v-model="telegramChannelForm.firstName"
                ></el-input>
              </el-form-item>
              <el-form-item label="Last name">
                <el-input
                  placeholder="FM"
                  v-model="telegramChannelForm.lastName"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>

      <el-form
        :model="telegramChannelForm"
        v-if="activeStep == 1"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col
            :offset="4"
            :span="18"
          >
            <el-alert
              v-if="telegramSignInError"
              title="Sign In Failed"
              type="error"
              description="The code you entered is invalid or has expired. Please try again or request a new code."
            >
            </el-alert>
            <br />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="12"
            :offset="6"
          >
            <el-form-item label="Code">
              <el-input
                placeholder="Enter code here"
                v-model="telegramChannelForm.telegramCode"
                clearable
              >
                <el-button
                  @click="onClickRequestCode"
                  slot="append"
                  v-loading="loadingTelegramCodeRequest"
                >Resend code</el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span
        slot="footer"
        class="dialog-footer clearfix"
      >
        <span class="pull-right">
          <el-button
            @click="handleClose"
            plain
          >Cancel</el-button>
          <el-button
            v-if="activeStep == 0"
            class="pull-right"
            v-loading="loadingTelegramCodeRequest"
            @click="onClickRequestCode"
            type="primary"
          >Request code</el-button>
          <el-button
            v-if="activeStep == 1"
            v-loading="loadingTelegramSignIn"
            @click="onClickSignIn"
            type="primary"
          >Sign in</el-button>
        </span>
      </span>

    </el-dialog>
  </div>

</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import humanizeDuration from 'humanize-duration';
import CountryCodeSelector from '@/components/common/countries/CountryCodeSelector';

export default {
  name: 'TelegramChannelCreate',
  components: {
    CountryCodeSelector,
  },
  data() {
    return this.initialData();
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
    countryCode() {
      return this.selectedCountry.dial_code ? this.selectedCountry.dial_code.substring(1) : null;
    },
    ...mapState('user', ['userCountryCode', 'me']),
    ...mapState('telegram', [
      'loadingTelegramCodeRequest',
      'telegramCodeRequestSuccess',
      'telegramPhoneCodeHash',
      'loadingTelegramSignIn',
      'telegramSignInStatus',
      'telegramSignInError',
      'telegramStatusMessage',
      'telegramClientStatus',
      'telegramCodeRequestError',
    ]),
  },
  methods: {
      initialData() {
        return {
          selectedCountry: {
           code: null,
            dial_code: null,
           flag: null,
          },
          telegramChannelForm: {
           telegramCode: '',
           firstName: '',
           lastName: '',
           phoneNumber: '',
          },
         activeStep: 0,
         codeRequestHasFailed: false,
         fullPhoneNumber: '',
         existingAccount: 'Yes',
         errorMessage: null,
        validationError: false,
      };
    },
    handleCountryChanged(country) {
      this.selectedCountry = country;
      this.telegramChannelForm.countryCode = this.countryCode;
    },
    next() {
      this.activeStep += 1;
      if (this.activeStep > 3) this.activeStep = 0;
    },
    onClickRequestCode() {
      this.validationError = null;
      if (this.selectedCountry.dial_code && this.telegramChannelForm.phoneNumber.length > 0) {
        const dialCode = this.selectedCountry.dial_code.substring(1);
        this.fullPhoneNumber = `${dialCode}${this.telegramChannelForm.phoneNumber}`;
        this.$store.dispatch('telegram/requestCode', {
          phone_number: this.fullPhoneNumber,
          company_id: this.me.use_as_company,
          user_id: this.me.id,
        });
      } else {
        this.validationError = true;
        this.errorMessage = 'Please provide your country code and phone number to proceed.';
      }
    },
    onClickChangeNumber() {
      this.activeStep = 0;
    },
    onClickSignIn() {
      const payload = {
        phone_number: this.fullPhoneNumber,
        code: this.telegramChannelForm.telegramCode,
        first_name: this.telegramChannelForm.firstName,
        last_name: this.telegramChannelForm.lastName,
      };

      this.$store.dispatch('telegram/confirmCode', payload);
    },
    handleClose() {
      this.showDialog = false;
      this.activeStep = 0;
      Object.assign(this.$data, this.initialData());
    },
    handle400() {
      this.errorMessage = 'Please make sure you provided the correct mobile number and dail code.';
    },
    handle403() {
      return 'Telegram has blocked your number for privacy violations.';
    },
    handle408() {
      return "The request has timed out. Please try again."
    },
    handle409() {
      return 'This number already has an active Telegram session.';
    },
    handle429(message) {
      const seconds = message.match(/\d+/g);
      const duration = humanizeDuration(seconds * 1000, {
        conjunction: ' and ',
        serialComma: false,
      });
      return `You have made too many login attempts. Please wait ${duration} before your next attempt.`;
    },
    handle500() {
      return 'We are currently unable to add your number. Please try again later or contact COLONYLive support.';
    },
    handleError(error) {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            this.errorMessage = this.handle400();
            break;

          case 403:
            this.errorMessage = this.handle403();
            break;

          case 408:
            this.errorMessage = this.handle408();

          case 409:
            this.errorMessage = this.handle409();
            break;

          case 429:
            this.errorMessage = this.handle429(error.response.data.message);
            break;

          default:
            this.errorMessage = this.handle500();
        }
      }
    },
  },
  watch: {
    telegramClientStatus() {
      switch (this.telegramClientStatus) {
        case 'connected':
          this.activeStep = 3;
          this.$notify({
            title: 'Success',
            message: 'You have successfully signed into your Telegram account ',
            type: 'success',
          });
          break;

        case 'waiting':
          this.activeStep = 1;
          break;

        default:
      }
    },
    loadingTelegramCodeRequest() {
      if (!this.loadingTelegramCodeRequest) {
        this.codeRequestHasFailed = true;
      }
      if (this.telegramCodeRequestSuccess && this.telegramPhoneCodeHash !== undefined) {
        if (this.activeStep === 0) this.next();
        this.codeRequestHasFailed = false;
      }
    },
    telegramSignInStatus() {
      this.handleError(this.telegramSignInError);
    },
    telegramCodeRequestError() {
      this.handleError(this.telegramCodeRequestError);
    },
    telegramSignInStatus() {
      if (this.telegramSignInStatus === 'success') {
        this.activeStep = 3;
        this.$notify({
          title: 'Success',
          message: 'You have successfully  signed into your Telegram account ',
          type: 'success',
        });
      }
    },
    activeStep() {
      if (this.activeStep === 3) {
        this.showDialog = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.country-selector {
  width: 100%;
}

.center {
  text-align: center;
}

.telegramSteps {
  padding-bottom: 20px;
}

.alert {
  margin-bottom: 20px;
}

.requestButton {
  margin: 0 auto;
}

.el-alert__content {
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// TelegramNewDialog.vue?70ee8e45